import {createSlice} from "@reduxjs/toolkit";
import {
  getRefundCustomerDetail,
  submitRefundCustomerDetail
} from "@/store/refund-form/action";


const initialState = {
  state: {
    refund: null,
    expiredLink: false
  },
  loading: true,
  error: ''
} as BaseState<RefundFormDetailState>

const slice = createSlice({
  name: 'refundFormDetailSlice',
  initialState,
  reducers: {
    resetRefundFormDetail: () => ({ ...initialState }),
  },
  extraReducers: (builder) => {
    // get refund customer detail
    builder.addCase(getRefundCustomerDetail.fulfilled, (state, action) => ({
      ...state,
      state: {
        ...state.state,
        expiredLink: !action.payload,
        refund: {
          ...action.payload,
          customer_info: {
            account_name: '',
            account_number: '',
            bank_code: ''
          }
        }
      },
      error: '',
      loading: false
    }))
    builder.addCase(getRefundCustomerDetail.rejected, (state) => ({
        ...state,
        state: {
          ...state.state,
          expiredLink: true
        },
        error: 'Failed to get refund detail data',
        loading: false
      }
    ))
    builder.addCase(getRefundCustomerDetail.pending, (state) => ({
        ...state,
        loading: true
      }
    ))
    // submit refund customer detail
    builder.addCase(submitRefundCustomerDetail.fulfilled, (state, action) => ({
      ...state,
      state: {
        ...state.state,
        successSubmit: !!action.payload
      },
      error: '',
      loading: false
    }))
    builder.addCase(submitRefundCustomerDetail.rejected, (state) => ({
        ...state,
        error: 'Failed to get refund detail data',
        loading: false
      }
    ))
    builder.addCase(submitRefundCustomerDetail.pending, (state) => ({
        ...state,
        loading: true
      }
    ))
  }
})

export default slice
